import { jsx } from 'react/jsx-runtime';
import { GenericConfigSection } from './GenericConfigSection.js';

const ConfigSubSection = ({ children, ...props }) => {
  return /* @__PURE__ */ jsx(GenericConfigSection, { ...props, kind: "sub-section", children });
};

export { ConfigSubSection };
//# sourceMappingURL=ConfigSubSection.js.map
